<script>
import { mapGetters } from 'vuex';
import offersHelper from '@/utils/helpers/offers';
import pathText from '@/utils/helpers/pathText';
import PreBookedOffers from '@/components/procedures/prebookStepper/PreBookedOffers.vue';

export default {
  name: 'step-wrapper',
  components: {
    PreBookedOffers,
  },
  props: {
    actualStep: Number,
    isMinarm: Boolean,
    step: Number,
    stepTextPath: String,
    signedOffer: Object,
  },
  computed: {
    ...mapGetters({
      demandStore: 'demandStore/demand',
      nbDaysBookingLimit: 'projectStore/nbDaysBookingLimit',
      offersStore: 'offerStore/offers',
      projectSelected: 'projectStore/projectSelected',
    }),
    isIndividual() {
      return this.projectSelected.params.is_individual;
    },
    isValidationDoneByPartner() {
      return this.projectSelected.params.partner_validates_quotes;
    },
    prebookedOffers() {
      return offersHelper.getPrebookedOffers(this.offersStore);
    },
    isVeryFirstState() {
      return offersHelper.isInitialState(
        this.offersStore,
        this.projectSelected.params.prebooked,
      );
    },
  },
  methods: {
    getTextType(text) {
      return pathText.getTextType(text);
    },
    getStepText(textKey, params) {
      const minarmPath = `procedures.minarmSteps.${this.stepTextPath}.${textKey}`;
      if (this.isMinarm && this.$te(minarmPath)) {
        return this.$t(minarmPath, params);
      }
      return pathText.getTextVersion(`procedures.steps.${this.stepTextPath}.${textKey}`, {
        isIndividual: this.isIndividual,
        // TODO if we need arrhesPercent, specify it here
        arrhesPercent: 0,
        nbDays: this.nbDaysBookingLimit,
        ...params,
      });
    },
  },
};
</script>
